import { takeLatest } from 'redux-saga/effects';
import {
  getEmployeeReferralListSuccess, getEmployeeReferralListFail,
  getEmployeeReferralDetailsSuccess, getEmployeeReferralDetailsFail,
  getCareersJobPostListSuccess, getCareersJobPostListFail,
  getReferralRelationListSuccess, getReferralRelationListFail,
} from './employeeReferralState';
import createCrudService from '../../services/crudservice';
import { 
  doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
  createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/console/employee-referrals');
const redirectData = { route:'/console/employee-referrals', mode:'list', recordId:0 };
const modelName = 'Employee Referral';
const modelId = 'erf_id';
const careersService = createCrudService('api/v1/public');

function* getEmployeeReferralList(data) {
  yield doCrudCall(
    () => crudService.getList(data.payload),
    getEmployeeReferralListSuccess,
    getEmployeeReferralListFail,
    null,
    null,
    LOADING_MSG
  );
}

function* getEmployeeReferralDetails(data) {
  yield doCrudCall(
    () => crudService.getDetails(data.payload),
    getEmployeeReferralDetailsSuccess,
    getEmployeeReferralDetailsFail,
    null,
    null,
    LOADING_MSG
  );
}

function* doEmployeeReferralCreate(data) {
  yield doCrudCall(
    () => crudService.doCreate(data.payload),
    getEmployeeReferralDetailsSuccess,
    getEmployeeReferralDetailsFail,
    createRecordSuccess(modelName),
    { ...redirectData, mode:'reload' },
    SAVING_MSG
  );
}

  function* doEmployeeReferralUpdate(data) {
    const reloadActions = [
      "update_status",
    ];

    const redirect =
      reloadActions.includes(data.payload.action)
        ? { ...redirectData, mode: "reload" }
        : redirectData;

    yield doCrudCall(
      () =>
        crudService.doUpdate(
          data.payload.crf_id,
          data.payload
        ),
      getEmployeeReferralDetailsSuccess,
      getEmployeeReferralDetailsFail,
      updateRecordSuccess(modelName),
      redirect,
      UPDATING_MSG
    );
  }

function* doEmployeeReferralDelete(data) {
  yield doCrudCall(
    () => crudService.doDelete(data.payload.recordId),
    getEmployeeReferralDetailsSuccess,
    getEmployeeReferralDetailsFail,
    deleteRecordSuccess(modelName),
    { ...redirectData, mode:data.payload.mode },
    DELETING_MSG
  );
}

function* getCareersJobPostList(data) {
  yield doCrudCall(
    () => careersService.doGetRequest('job-posts', data.payload),
    getCareersJobPostListSuccess,
    getCareersJobPostListFail,
    null,
    null,
    LOADING_MSG
  );
}
 
function* getReferralRelationList(data) {
  yield doCrudCall(
    () => careersService.doGetRequest('options/referral-relation-list', data.payload),
    getReferralRelationListSuccess,
    getReferralRelationListFail,
    null,
    null,
    LOADING_MSG
  );
}

function* employeeReferralSaga() {
  yield takeLatest('employeeReferral/getEmployeeReferralList', getEmployeeReferralList);
  yield takeLatest('employeeReferral/getEmployeeReferralDetails', getEmployeeReferralDetails);
  yield takeLatest('employeeReferral/doEmployeeReferralCreate', doEmployeeReferralCreate);
  yield takeLatest('employeeReferral/doEmployeeReferralUpdate', doEmployeeReferralUpdate);
  yield takeLatest('employeeReferral/doEmployeeReferralDelete', doEmployeeReferralDelete);
  yield takeLatest('employeeReferral/getCareersJobPostList', getCareersJobPostList);
  yield takeLatest('employeeReferral/getReferralRelationList', getReferralRelationList);
}

export default employeeReferralSaga;
